import { getBookingPrecision } from '@clubmed/domains-service';
import { getStayTransportFragment } from 'Views/account/stay/StayView.queries';
export const getDevice = (responsive: ResponsiveProps) => {
  if (responsive.isDesktop) {
    return 'DESKTOP';
  }

  if (responsive.isTablet) {
    return 'TABLET';
  }

  return 'MOBILE';
};
export const getPrePaymentDetailsQuery = (appContext: AppContext, bookingId: string) => `query {
    customerBooking(id:"${bookingId}") {
      attendees {
        birthday
        customerId
        email
        firstName
        id
        lastName
      }
      categories {
        isOption
      }
      id
      payment {
        due {
          deadlineDate
          formattedValue(precision: ${getBookingPrecision(appContext.locale)})
          value
        }
        total {
          formattedValue(precision: ${getBookingPrecision(appContext.locale)})
          value
        }
      }
      status {
        name
      }
      stays {
        accommodationsCount
        booking {
          attendees {
            birthday
            customerId
            email
            firstName
            id
            lastName
          }
          categories {
            isOption
            isTravelPlan
          }
          id
          payment {
            isEnabled
            due {
              deadlineDate
              formattedValue(precision: ${getBookingPrecision(appContext.locale)})
              value
            }
            total {
              formattedValue(precision: ${getBookingPrecision(appContext.locale)})
              value
            }
          }
          status {
            name
          }
          vendor {
            isSoldByPartners
          }    
        }
        dates {
          duration
          endDate
          startDate
        }          
        id
        participants {
          adultsCount
          attendees {
            birthday
            firstname
            id
            isAdult
            isKid
            lastname
            unicodeFirstname
            unicodeLastname
          }
          childrenCount
          totalCount
        }
        product {
          badgeIcon
          comfort
          destination {
            country
          }
          hasECSpace
          href
          image
          isCruise
          isExplicitEC
          isJoyview
          name
        }
        transport {
          fromCity
          fromCityCode
          inbounds {
            ...transportsDetails
          }    
          outbounds {
            ...transportsDetails
          }
          toCity
          toCityCode
          type
          types
        }
        transfers {
          id
        }
        upsells(types: [TRANSFER], withAllSolded: true) {
          transfers {
            pricingInfo {
              id
              isFullyPaid
              isFullyRented
              isIncluded
              isPartiallyPaid
              isPartiallyRented
            }
          }
        }
      }
      vendor {
        isSoldByPartners
      }
    }
    legalInformations {
      optionConfirmation {
        description
        id
        label
        preChecked
        required
        url
      }
    }
    paymentProviders(isCa: true, bookingId: "${bookingId}"){
      description
      id
      label
      logo
      categoryPaymentMethod
      withBillingAddress
      shouldSkipPayment
      paymentMethods {
        category
        id
        image
        label
        timePaymentConditions {
          chargePercentage
          id
          paymentCount
        }
      }
      requiredDelayBeforeDeparture
      selectorId
      token {
        format
        value
      }
    }
  }${getStayTransportFragment()}`;
